import { IFaireMoney } from '@faire/web-api--source/indigofair/data/IFaireMoney';
import { SettingConst } from '@faire/web-api--source/types';

/**
 * The credit amount of retailer small business grant program.
 */
export const OWF_GRANT_CREDITS_BY_COUNTRY =
  'OWF_GRANT_CREDITS_BY_COUNTRY' as SettingConst<
    'OWF_GRANT_CREDITS_BY_COUNTRY',
    IFaireMoney,
    'RETAILER' | 'VISITOR_WEB'
  >;
